import { Building, Facebook, Linkedin, Mail, Phone } from "lucide-react";
import { useLanguage } from '@/contexts/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  return (
    <footer className="bg-blue-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-xl font-bold mb-4">Leader Promed</h3>
            <p className="text-blue-100 mb-6">{t('footer.description')}</p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/profile.php?id=100086261242323" className="bg-blue-800 p-2 rounded-full text-blue-200 hover:bg-blue-700 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.linkedin.com/company/leaderpromed" className="bg-blue-800 p-2 rounded-full text-blue-200 hover:bg-blue-700 transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-blue-100 hover:text-white transition-colors">{t('footer.link.home')}</a></li>
              <li><a href="/about" className="text-blue-100 hover:text-white transition-colors">{t('footer.link.about')}</a></li>
              <li><a href="/services" className="text-blue-100 hover:text-white transition-colors">{t('footer.link.services')}</a></li>
              <li><a href="/partners" className="text-blue-100 hover:text-white transition-colors">{t('footer.link.partners')}</a></li>
              <li><a href="/news" className="text-blue-100 hover:text-white transition-colors">{t('footer.link.news')}</a></li>
              <li><a href="/contact" className="text-blue-100 hover:text-white transition-colors">{t('footer.link.contact')}</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.contact')}</h3>
            <address className="not-italic text-blue-100 space-y-2">
              <div className="flex items-center gap-2">
                <Building size={16} />
                <span>{t('footer.address')}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} />
                <span>{t('footer.phone')}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <a href="mailto:contact@leaderpromed.com" className="hover:text-white transition-colors">
                  {t('footer.email')}
                </a>
              </div>
            </address>
          </div>
        </div>
        
        <div className="border-t border-blue-800 mt-8 pt-8 text-center">
          <p className="text-blue-200">
            &copy; {new Date().getFullYear()} Leader Promed. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 